import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as IconCloseLight } from "../../../asserts/imgs/chart/fubon/close_24px_rounded_light.svg";
import common from "../../../asserts/js/common";

export const WC = (props) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [weight, setWeight] = useState(2.0);
  const [color, setColor] = useState("AA2211");
  const [thickness, setThickness] = useState(2);
  const [style, setStyle] = useState("s");
  const [showTracker, setShowTracker] = useState(true);
  const [value, setValue] = useState(weight);

  const [localChartSetting, setLocalChartSetting] = useState(null)

  useEffect(() => {
    let localSetting = common.getlocalChartStorage();

    if (localSetting)
      setLocalChartSetting(localSetting.WC_Option)
  }, []);

  useEffect(() => {
    if (localChartSetting) {
      try {
        const WC = localChartSetting.option;

        setValue(WC.weight);
        props.onOverlayValueChange({
          ta: "WC",
          name: `${t("chart5.TAWC..WC")} (WC)`,
          option: {
            weight: WC.weight,
            color: WC.color,
            thickness: WC.thickness,
            style: WC.style,
            showTracker: WC.showTracker,
          },
          value: localChartSetting.value,
        });
      } catch { }
    }
  }, [localChartSetting]);

  useEffect(() => {
    const WC = props.localChartSetting.WC_Option.option;

    setColor(WC.color);
    setWeight(parseFloat(WC.weight) || weight);
    setThickness(parseInt(WC.thickness) || thickness);
    setStyle(WC.style);
    setShowTracker(WC.showTracker);

  }, [props.localChartSetting]);

  useEffect(() => {
    setValue(weight);
    props.onOverlayValueChange({
      ta: "WC",
      name: `${t("chart5.TA.WC")} (WC)`,
      option: {
        weight: weight,
        color: color,
        thickness: thickness,
        style: style,
        showTracker: showTracker,
      },
      value: value,
    });
  }, [weight, color, thickness, style, showTracker]);

  useEffect(() => {
    setTAColor();
  }, [props.selectedColor]);

  useEffect(() => {
    setIsOpen(props.isOpen);
  }, [props.isOpen]);

  useEffect(() => {
    const WC = props.localChartSetting.WC_Option.option;

    setColor(WC.color);
    setWeight(parseFloat(WC.weight) || weight);
    setThickness(parseInt(WC.thickness) || thickness);
    setStyle(WC.style);
    setShowTracker(WC.showTracker);
  }, [props.isReset]);

  const resetALL = () => {
    setColor("AA2211");
    setWeight(2.0);
    setThickness(2);
    setStyle("s");
    setShowTracker(true);
  };

  const onResetClick = () => {
    const answer = window.confirm(t("chart5.alertMsg"));
    if (answer) {
      setIsOpen(true);
      resetALL();
    } else {
      setIsOpen(true);
    }
  };

  const openOptionBox = (e) => {
    try {
      if (
        e.target.className.replace(" focus-within", "") ===
        "menusubitem msiaction techicaloverlay" ||
        e.target.className.replace(" focus-within", "") === "span" ||
        e.target.className.replace(" focus-within", "") === "optboxarrow" ||
        e.target.className.replace(" focus-within", "") === "msiicon"
      ) {
        if (e.target.className.replace(" focus-within", "") !== "b2dbtn") {
          if (isOpen) setIsOpen(false);
          else setIsOpen(true);
        }
      }
    } catch (err) { }
  };

  // id: string
  const removeOverLay = (id) => {
    props.removeOverLay(id);
  };

  const onWeightChange = (e) => {
    setWeight(e.target.value);
  };

  const onThicknessChange = (e) => {
    setThickness(e.target.value);
  };

  const onStyleChange = (e) => {
    setStyle(e.target.value);
  };

  const onShowTracker = () => {
    if (showTracker) setShowTracker(false);
    else setShowTracker(true);
  };

  const setTAColor = () => {
    switch (props.source) {
      case "WC":
        setColor(props.selectedColor);
        break;
    }
  };

  const onColorClick = () => {
    props.onColorClick(color, "WC", t("chart5.setting"));
  };

  return (
    <div
      className="menusubitem msiaction techicaloverlay"
      id="msi-ta"
      onClick={(e) => openOptionBox(e)}
    >
      {/* <div className="msiicon" onClick={() => removeOverLay("WC")}></div> */}
      <div className="box-container">
        <span className="span">
          {t("chart5.TA.WC")} (WC) {value}
        </span>
        <IconCloseLight
          className="close-icon"
          onClick={() => removeOverLay("WC")}
        />
      </div>
      <div
        className="optboxarrow"
        style={isOpen ? { transform: "rotate(180deg)" } : {}}
        onClick={(e) => openOptionBox(e)}
      ></div>
      <div
        className="b2dbtn"
        style={isOpen ? { display: "flex" } : {}}
        title="スタイル設定を初期設定に戻す"
        onClick={onResetClick}
      ></div>
      <div className="msi-optbox" style={isOpen ? {} : { display: "none" }}>
        <div className="menusubitem " id="msi-ta-WC">
          <div className="flexbox">
            <div className="taparamlbl">{t("chart5.weight")}: x</div>
            <div className="inputbox taparam">
              <input
                id="msi-ta-WC-p0-period0"
                type="number"
                step="0.1"
                min="1.0"
                value={weight}
                maxLength={4}
                style={{ width: "40px" }}
                onChange={(e) => onWeightChange(e)}
              />
            </div>
          </div>

          <div className="menusubitem stylebox ">
            <div className="styleboxlbl">{t("chart5.setting")}</div>
            <button
              id="msi-ta-WC-p0-color0"
              className="colorpicker"
              value={color}
              data-colorpickerdialogtitle="表示設定"
              style={{ backgroundColor: "#" + color }}
              onClick={onColorClick}
            ></button>
            <div className="inputbox">
              <input
                id="msi-ta-WC-p0-thickness"
                type="number"
                step="1"
                min="1"
                max="9"
                value={thickness}
                maxLength={1}
                style={{ width: "30px" }}
                onChange={(e) => onThicknessChange(e)}
              />
            </div>
            <div className="selectbox" onChange={(e) => onStyleChange(e)}>
              <select id="msi-ta-WC-p0-style" value={style}>
                <option value="s">{t("chart5.realLine")}</option>
                <option value="d">{t("chart5.dotLine")}</option>
              </select>
            </div>
            <div className="showtracker">
              <div
                id="msi-ta-WC-p0-showtracker"
                className={
                  showTracker ? "checkboxbutton-selected" : "checkboxbutton"
                }
                onClick={onShowTracker}
              ></div>
              <div className="styleboxlbl">{t("chart5.showValue")}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
